module.exports = __webpack_public_path__ + "171ac431f4165f302aea6df714374bc1.jpg";